import React from "react";
import { motion } from "framer-motion";
import { Award, Globe2, Layers, Sparkles } from "lucide-react";

const features = [
  {
    icon: Award,
    title: "Experts certifiés",
    desc: "Des consultants certifiés ISO 27001 Lead Auditor / Implementer, EBIOS RM, et formations défensives reconnues (SANS, OSCP).",
  },
  {
    icon: Globe2,
    title: "France 🇫🇷 & Sénégal 🇸🇳",
    desc: "Une double implantation France–Sénégal pour une proximité culturelle et opérationnelle avec vos équipes locales.",
    highlight: true,
  },
  {
    icon: Layers,
    title: "Double expertise",
    desc: "Gouvernance ET défense opérationnelle — un alignement complet entre votre stratégie et votre run sécurité.",
  },
  {
    icon: Sparkles,
    title: "Approche pragmatique",
    desc: "Nous délivrons des résultats mesurables, pas de la théorie. Outils, runbooks et procédures prêts à l'emploi.",
  },
];

export default function WhyBaobSec() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="font-mono text-xs text-emerald-400 mb-4 tracking-widest">
              // POURQUOI BAOBSEC
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
              La force d'un{" "}
              <span className="italic text-emerald-400">baobab,</span>
              <br />
              l'agilité d'un partenaire dédié.
            </h2>
            <p className="mt-6 text-gray-400 leading-relaxed">
              Comme le baobab, symbole de force et de longévité, BaobSec déploie ses
              racines dans la durée : nous bâtissons des programmes sécurité qui
              tiennent, évoluent et résistent.
            </p>

            <div className="mt-10 relative">
              <div className="absolute -inset-4 bg-emerald-500/10 blur-3xl rounded-3xl" />
              <blockquote
                data-testid="differentiators-section"
                className="relative rounded-2xl border border-emerald-500/20 bg-[#0C1410]/80 backdrop-blur p-6"
              >
                <div className="font-mono text-[11px] text-emerald-400 mb-2 tracking-widest">
                  / NOTRE PROMESSE
                </div>
                <p className="text-lg leading-relaxed">
                  "Une équipe qui parle aussi bien le langage du{" "}
                  <span className="text-emerald-400">RSSI</span> que celui du{" "}
                  <span className="text-emerald-400">SOC analyst</span>."
                </p>
              </blockquote>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {features.map((f, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  data-testid={`why-feature-${i}`}
                  className={`group relative p-7 rounded-2xl border transition-all hover:-translate-y-1 ${
                    f.highlight
                      ? "bg-gradient-to-br from-emerald-500/10 to-transparent border-emerald-500/30"
                      : "bg-[#0C1410] border-[#1A2E22] hover:border-emerald-500/40"
                  }`}
                >
                  <div className="inline-flex p-3 rounded-xl bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 mb-5">
                    <f.icon className="w-5 h-5" />
                  </div>
                  <h4 className="font-display text-xl font-semibold mb-2">
                    {f.title}
                  </h4>
                  <p className="text-sm text-gray-400 leading-relaxed">{f.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
